import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IStatus, STATUS_TYPE } from '../../../../../@core/models/model';
import { DialogComponent } from '../../../../../@core/components/ui/dialog/dialog.component';
import { StatusService } from '../../../../services/status.service';
import { ToastService } from '../../../../../@core/services/toast.service';
import { ButtonComponent } from "../../../../../@core/components/ui/button/button.component";

@Component({
    selector: 'app-project-status',
    imports: [
        FormsModule,
        ButtonModule,
        InputTextModule,
        ButtonComponent,
        DialogComponent
    ],
    standalone: true,
    templateUrl: './project-status.component.html',
    styleUrls: ['./project-status.component.scss']
})
export class ProjectStatusComponent implements OnInit {
    statuses: IStatus[] = [];

    // Form dialog
    showFormDialog = false;
    form: { _id?: string; name: string } = { name: '' };
    editing = false;
    originalName = '';

    // Delete dialog
    showDeleteDialog = false;
    target: IStatus | null = null;

    constructor(
        private statusService: StatusService,
        private toast: ToastService
    ) { }

    ngOnInit() {
        this.loadStatuses();
    }

    trackById(_idx: number, item: IStatus) {
        return item._id;
    }

    get hasChanges(): boolean {
        if (!this.editing) return true;
        return this.form.name.trim() !== this.originalName.trim();
    }

    private loadStatuses() {
        this.statusService.getStatuses(STATUS_TYPE.PROJECT).subscribe(res => {
            if (res.success) {
                this.statuses = res.data;
            } else {
                this.toast.error('Failed to fetch statuses.');
            }
        });
    }

    // ----- Add / Edit -----

    openAddDialog() {
        this.editing = false;
        this.form = { name: '' };
        this.showFormDialog = true;
    }

    openEditDialog(s: IStatus) {
        this.editing = true;
        this.form = { _id: s._id, name: s.name };
        this.originalName = s.name;
        this.showFormDialog = true;
    }

    save() {
        const name = this.form.name.trim();
        if (!name) {
            this.toast.error('Name cannot be empty.');
            return;
        }

        if (this.editing && this.form._id) {
            // Update
            this.statusService
                .updateStatus(this.form.name, this.form._id, STATUS_TYPE.PROJECT)
                .subscribe(res => {
                    if (res.success) {
                        const idx = this.statuses.findIndex(s => s._id === res.data._id);
                        if (idx > -1) this.statuses[idx] = res.data;
                        this.toast.success('Status updated.');
                        this.showFormDialog = false;
                    }
                });
        } else {
            // Create
            this.statusService
                .addStatus(this.form.name, STATUS_TYPE.PROJECT)
                .subscribe(res => {
                    if (res.success) {
                        this.statuses.push(res.data);
                        this.toast.success('Status added.');
                        this.showFormDialog = false;
                    }
                });
        }
    }

    resetForm() {
        this.showFormDialog = false;
        this.editing = false;
        this.form = { name: '' };
        this.originalName = '';
    }

    // ----- Delete -----

    openDeleteDialog(s: IStatus) {
        this.target = s;
        this.showDeleteDialog = true;
    }

    confirmDelete() {
        if (!this.target) return;
        this.statusService.deleteStatus(this.target._id).subscribe(res => {
            if (res.success) {
                this.statuses = this.statuses.filter(s => s._id !== this.target!._id);
                this.toast.success('Status deleted.');
            } else {
                this.toast.error('Failed to delete.');
            }
            this.showDeleteDialog = false;
            this.target = null;
        });
    }

    closeDeleteDialog() {
        this.showDeleteDialog = false;
        this.target = null;
    }
}

